module.exports = __webpack_public_path__ + "img/title31734491223780.png";